export interface Resource {
  id: string;
  name: string;
  displayName: string;
  uris: string[];
  type: string;
}

export interface Resources {
  reports: Resource[];
}

export interface ResourceSelected {
    id: string;
    name: string;
    type:string;
  }
  
export interface resourcesState {
  resources: {
    loading: boolean;
    data: Resources[] | any;
    error: string | any;
  };
  resourceSelected:ResourceSelected | any;
}

export interface Error {
  status: string;
  message: string;
}

export enum resourceTypeEnum {
  DATASETS = "datasets",
  REPORT = "report",
}

export interface Filter {
  name: string;
  values: string[];
}

export type type = resourceTypeEnum.REPORT | resourceTypeEnum.DATASETS;
